<ng-container *ngIf="(common_service.athleteDetailStore.dataStream.asObservable()|async)[0] as season">
  <ng-template #noresults>
    <ng-container>
      <span
        class="progress-bar-stats__info__percentage-only uppertext-black-no-viewport"
      ></span> 
    </ng-container>
  </ng-template>

  <ng-template #noresultspercent>
    <ng-container>
      <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage" >0 - 0</span>
      <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage__small"> 0% </span>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="hasSeasonData()">
    <div>
      
      <div class="menu-select">
        <a
          [ngClass]="{ 'menu-select__active': view === 1 }"
          *ngIf="data != null && (data[0]?.Stats)['Season']"
          class="uppertext-no-viewport"
          (click)="setView(1)"
          >{{'Current_season' | transloco}}</a
        >
        <a
          [ngClass]="{ 'menu-select__active': view === 2 }"
          *ngIf="data != null && (data[0]?.Stats)['LastSeason']"
          class="uppertext-no-viewport"
          (click)="setView(2)"
          >{{'Last_season' | transloco}}</a

        >
        <a
          [ngClass]="{ 'menu-select__active': view === 3 }"
          *ngIf="data != null && (data[0]?.Stats)['Career']"
          class="uppertext-no-viewport"
          (click)="setView(3)"
          >{{'Career' | transloco}}</a
        >
      </div>
     
      <div class="progress-bar-stats" *ngIf="getSeasonData() as season">
        <ng-template #mobileGraph>
          <div class="progress-section-wrapper">
            <div class="progress-wrapper">
              <ngx-charts-pie-chart
                arcWidth="0.4"
                *ngIf="isSelectedGraph(1)"
                [scheme]="customColors"
                [tooltipDisabled]="false"
                [legend]="false"
                [doughnut]="true"
                tooltipDisabled="true"
                [view]="[200, 200]"
                [results]="seasonMap.avg"
              ></ngx-charts-pie-chart>
              <div *ngIf="isSelectedGraph(1)" class="progress-bar-stats__info">
                <ng-container *ngIf="season?.AverageArr; else noresults">
                <span
                  class="progress-bar-stats__info__percentage-only uppertext-black-no-viewport"
                  >{{ season?.AverageArr?.toFixed(2) }}</span
                >
              </ng-container>
              </div>
            </div>
            <div class="progress-wrapper">
              <ngx-charts-pie-chart
                arcWidth="0.4"
                *ngIf="isSelectedGraph(2)"
                [scheme]="customColors"
                [tooltipDisabled]="false"
                [legend]="false"
                [doughnut]="true"
                tooltipDisabled="true"
                [view]="[200, 200]"
                [results]="seasonMap.matches"
              ></ngx-charts-pie-chart>
              <div class="progress-bar-stats__info" *ngIf="isSelectedGraph(2)">
                <ng-container *ngIf="season && season.MatchWin; else noresultspercent">
                  <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage">{{ season?.MatchWin }} - {{ season?.MatchTot - season?.MatchWin }}</span>
                  <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage__small">{{ season?.MatchWinPercentage?.toFixed(0) }}%</span>
                </ng-container>
               </div>
            </div>
            <div class="progress-wrapper">
              <ngx-charts-pie-chart
                arcWidth="0.4"
                *ngIf="isSelectedGraph(3)"
                [scheme]="customColors"
                [tooltipDisabled]="false"
                [legend]="false"
                [doughnut]="true"
                tooltipDisabled="true"
                [view]="[200, 200]"
                [results]="seasonMap.tier"
              ></ngx-charts-pie-chart>
     
              <div *ngIf="isSelectedGraph(3)" class="progress-bar-stats__info">
                <ng-container *ngIf="season && season.TBWin;else noresultspercent">
                  <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage">{{ season?.TBWin }} - {{ season?.TBTot - season?.TBWin  }}</span>
                  <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage__small">{{ season?.TBWinPercentage?.toFixed(0) }}%</span>
                </ng-container>
              </div>
             
            </div>
            <div class="progress-wrapper">
              <ngx-charts-pie-chart
                arcWidth="0.4"
                *ngIf="isSelectedGraph(4)"
                [scheme]="customColors"
                [tooltipDisabled]="false"
                [legend]="false"
                [doughnut]="true"
                tooltipDisabled="true"
                [view]="[200, 200]"
                [results]="seasonMap.round"
              ></ngx-charts-pie-chart>
              <div *ngIf="isSelectedGraph(4)" class="progress-bar-stats__info">
                <ng-container *ngIf="season && season.QBest;else noresults">
                <span
                  class="uppertext-black-no-viewport progress-bar-stats__info__percentage-only">{{ season?.QBest }}</span
                >
                </ng-container>

              </div>
            </div>
            <div class="selections">
              <p (click)="selectGraph(1)" [ngClass]="{ 'progress-bar-stats__active': isSelectedGraph(1) }" class="progress-bar-stats__title uppertext-no-viewport">
                {{'Average_Arrow' | transloco}}
              </p>
              <p
                (click)="selectGraph(2)"
                [ngClass]="{ 'progress-bar-stats__active': isSelectedGraph(2) }"
                class="progress-bar-stats__title uppertext-no-viewport"
              >
                {{'Matches' | transloco}}
              </p>
              <p
                (click)="selectGraph(3)"
                [ngClass]="{ 'progress-bar-stats__active': isSelectedGraph(3) }"
                class="progress-bar-stats__title uppertext-no-viewport"
              >
                {{'Tiebreaks' | transloco}}
              </p>
              <p
                (click)="selectGraph(4)"
                [ngClass]="{ 'progress-bar-stats__active': isSelectedGraph(4) }"
                class="progress-bar-stats__title uppertext-no-viewport"
              >
                {{'Ranking_round' | transloco}}
              </p>
            </div>
          </div>
        </ng-template>


        <ng-container *ngIf="isMobileProperty === false; else mobileGraph">
          <div class="progress-wrapper">
            <div class="content-wrapper">
              <ngx-charts-pie-chart arcWidth="0.4" [scheme]="customColors" [tooltipDisabled]="false" [legend]="false" [doughnut]="true" tooltipDisabled="true" [view]="viewDesktop" [results]="seasonMap.avg">

              </ngx-charts-pie-chart>
              <div *ngIf="isMobileProperty === false" class="progress-bar-stats__info">
                <ng-container *ngIf="season?.AverageArr; else noresults">
                <span class="progress-bar-stats__info__percentage-only uppertext-black-no-viewport">{{ season?.AverageArr?.toFixed(2) }}</span>
               </ng-container>
              </div>
            </div>
            <p (click)="selectGraph(1)" [ngClass]="{ 'menu-select__active': view === isSelectedGraph(1) }" class="progress-bar-stats__title uppertext-no-viewport">
              {{'Average_Arrow' | transloco}}
            </p>
          </div>

          <div class="progress-wrapper">
            <div class="content-wrapper">
              <ngx-charts-pie-chart arcWidth="0.4" [scheme]="customColors" [tooltipDisabled]="false" [legend]="false" [doughnut]="true" tooltipDisabled="true" [view]="viewDesktop" [results]="seasonMap.matches">

              </ngx-charts-pie-chart>
              <div *ngIf="isMobileProperty === false" class="progress-bar-stats__info">
                <ng-container *ngIf="season && season?.MatchWin != null;else noresultspercent">
                <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage">{{ season?.MatchWin }} - {{ season?.MatchTot - season?.MatchWin  }}</span>
                <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage__small">{{ season?.MatchWinPercentage?.toFixed(0) }}%
                </span>
              </ng-container>
              </div>
            </div>
            <p (click)="selectGraph(2)" [ngClass]="{ 'menu-select__active': view === isSelectedGraph(2) }" class="progress-bar-stats__title uppertext-no-viewport">
              {{'Matches' | transloco}}
            </p>
          </div>

          <div class="progress-wrapper">
            <div class="content-wrapper">
              <ngx-charts-pie-chart  arcWidth="0.4" [scheme]="customColors" [tooltipDisabled]="false" [legend]="false" [doughnut]="true" tooltipDisabled="true" [view]="viewDesktop" [results]="seasonMap.tier">

              </ngx-charts-pie-chart>
              <div *ngIf="isMobileProperty === false" class="progress-bar-stats__info">
                <ng-container *ngIf="season && season.TBWin != null; else noresultspercent" >
                <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage">{{ season?.TBWin }} - {{ season?.TBTot - season?.TBWin }}</span>
                <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage__small">{{ season?.TBWinPercentage?.toFixed(0) }}%</span>
              </ng-container>
              </div>
            </div>
            <p (click)="selectGraph(3)" [ngClass]="{ 'menu-select__active': view === isSelectedGraph(3) }" class="progress-bar-stats__title uppertext-no-viewport">
              {{'Tiebreaks' | transloco}}
            </p>
          </div>

          <div class="progress-wrapper">
            <div class="content-wrapper">
              <ngx-charts-pie-chart arcWidth="0.4" [scheme]="customColors" [tooltipDisabled]="false" [legend]="false" [doughnut]="true" tooltipDisabled="true" [view]="viewDesktop" [results]="seasonMap.round">

              </ngx-charts-pie-chart>
              <div *ngIf="isMobileProperty === false" class="progress-bar-stats__info">
                <ng-container *ngIf="season && season.QBest != null;else noresults">
                <span class="uppertext-black-no-viewport progress-bar-stats__info__percentage-only">
                  {{ season?.QBest }}
                </span>
              </ng-container>
              </div>
            </div>
            <p (click)="selectGraph(4)" [ngClass]="{ 'menu-select__active': view === isSelectedGraph(4) }" class="progress-bar-stats__title uppertext-no-viewport">
              {{'Ranking_round' | transloco}}
            </p>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
